import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_BY_TRIAL_GROUP_LABORATORY_ID,
    ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_BY_ID,

    ACTION_TRIALGROUPLABORATORYFINANCE_SAVE,

    ACTION_TRIALGROUPLABORATORYFINANCE_CREATE,

    ACTION_TRIALGROUPLABORATORYFINANCE_VALIDATE,

    ITrialGroupLaboratoryFinanceLoadByTrialGroupLaboratoryIdAction,
    ITrialGroupLaboratoryFinanceLoadByIdAction,
    ITrialGroupLaboratoryFinanceLoadFailureAction,
    ITrialGroupLaboratoryFinanceLoadSuccessAction,

    ITrialGroupLaboratoryFinanceSaveAction,
    ITrialGroupLaboratoryFinanceSaveSuccessAction,
    ITrialGroupLaboratoryFinanceSaveFailureAction,

    ITrialGroupLaboratoryFinanceCreateAction,
    ITrialGroupLaboratoryFinanceCreateSuccessAction,
    ITrialGroupLaboratoryFinanceCreateFailureAction,

    ITrialGroupLaboratoryFinanceValidateAction,
    ITrialGroupLaboratoryFinanceValidateSuccessAction,
    ITrialGroupLaboratoryFinanceValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialGroupLaboratoryFinance";
import { trialGroupLaboratoryFinanceApi } from "../services/trialGroupLaboratoryFinance";

export const
    getTrialGroupLaboratoryFinanceByTrialGroupLaboratoryIdEpic = (action$): Observable<ITrialGroupLaboratoryFinanceLoadSuccessAction | ITrialGroupLaboratoryFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_BY_TRIAL_GROUP_LABORATORY_ID)
            .mergeMap((action: ITrialGroupLaboratoryFinanceLoadByTrialGroupLaboratoryIdAction) => {
                return trialGroupLaboratoryFinanceApi
                    .getTrialGroupLaboratoryFinanceByTrialGroupLaboratoryId(action.trialGroupLaboratoryId)
                    .map(response =>
                        LoadSuccess(response.trialGroupLaboratoryFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupLaboratoryFinanceByIdEpic = (action$): Observable<ITrialGroupLaboratoryFinanceLoadSuccessAction | ITrialGroupLaboratoryFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_BY_ID)
            .mergeMap((action: ITrialGroupLaboratoryFinanceLoadByIdAction) => {
                return trialGroupLaboratoryFinanceApi
                    .getTrialGroupLaboratoryFinanceById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialGroupLaboratoryFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialGroupLaboratoryFinanceEpic = (action$): Observable<ITrialGroupLaboratoryFinanceSaveSuccessAction | ITrialGroupLaboratoryFinanceSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYFINANCE_SAVE)
            .mergeMap((action: ITrialGroupLaboratoryFinanceSaveAction) => {
                return trialGroupLaboratoryFinanceApi
                    .setTrialGroupLaboratoryFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialGroupLaboratoryFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialGroupLaboratoryFinanceEpic = (action$): Observable<ITrialGroupLaboratoryFinanceCreateSuccessAction | ITrialGroupLaboratoryFinanceCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYFINANCE_CREATE)
            .mergeMap((action: ITrialGroupLaboratoryFinanceCreateAction) => {
                return trialGroupLaboratoryFinanceApi
                    .createTrialGroupLaboratoryFinance(action.trialGroupLaboratoryId)
                    .map(response =>
                        CreateSuccess(
                            response.trialGroupLaboratoryFinance,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialGroupLaboratoryFinanceEpic = (action$): Observable<ITrialGroupLaboratoryFinanceValidateSuccessAction | ITrialGroupLaboratoryFinanceValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORYFINANCE_VALIDATE)
            .mergeMap((action: ITrialGroupLaboratoryFinanceValidateAction) => {
                return trialGroupLaboratoryFinanceApi
                    .validateTrialGroupLaboratoryFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialGroupLaboratoryFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }